(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService','UserContacts', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, UserContacts,$translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        
        //CUSTOM
        vm.email = null;
        vm.telephone = null;
        vm.mobile = null;
        vm.fax = null;
        vm.isStudent = true;
        
        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });
        
        //Get current contacts
       var getUserContacts = function(){
    	   	UserContacts.get({}, function(result, headers) {
    	   		vm.email = result.email;
    	   		vm.telephone = result.telephone;
    	   		vm.mobile = result.mobile;
    	   		vm.fax = result.fax;
    	   		if(result.emailAlias!=null)
    	   			vm.mailAliases = result.emailAlias.split(";");
    	   		vm.isStudent = result.student;
    	   	});
       };

       getUserContacts();
       
       	function emptyToNull(stringa){
       		if(stringa === undefined || (stringa !== null && stringa.length == 0))
       			stringa = null;
       		
       		return stringa;
       	}
       	
       	
        function save () {
        	
        	vm.telephone = emptyToNull(vm.telephone);
        	vm.mobile = emptyToNull(vm.mobile);
        	vm.fax = emptyToNull(vm.fax);
        	vm.email = emptyToNull(vm.email);
        	
        	
        	UserContacts.save({telephone:vm.telephone,mobile:vm.mobile,fax:vm.fax,email:vm.email},function(result, headers) {
        		//Aggiorno solo se il salvataggio è andato a buon fine
        		updateAuth();
            },function(){
            	 vm.success = null;
                 vm.error = 'ERROR';
            });
        	
        	
           
        }
        
        function updateAuth(){
        	vm.settingsAccount.email = vm.email;
        	 Auth.updateAccount(vm.settingsAccount).then(function() {
                 vm.error = null;
                 vm.success = 'OK';
                 Principal.identity(true).then(function(account) {
                     vm.settingsAccount = copyAccount(account);
                 });
                 JhiLanguageService.getCurrent().then(function(current) {
                     if (vm.settingsAccount.langKey !== current) {
                         $translate.use(vm.settingsAccount.langKey);
                     }
                 });
             }).catch(function() {
                 vm.success = null;
                 vm.error = 'ERROR';
             });
        }
    }
})();
